export default __webpack_public_path__ + "static/media/edit.07dc37e4.svg";